export default __webpack_public_path__ + "static/media/login-sidebar-cover.f99abe73.png";